import Reflux from 'reflux';
import TransactionActions from 'actions/Transaction';

var TransactionStore = Reflux.createStore({
  listenables: [TransactionActions],
  data: {
    list: [],
    loading: true
  },

  getInitialState() {
    return this.data;
  },

  onRead(includeRead, callback) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.call(
      'payment/incoming',
      'read',
      { status: 184, sortBy: 'date', sortMode: 'desc' },
      response => {
        TransactionActions.readComplete(response.data);
        if (callback) {
          callback();
        }
      }
    );
  },

  onReadComplete(data) {
    this.data = {
      list: data,
      loading: false,
      saving: false,
      transaction: {}
    };
    this.trigger(this.data);
  },

  onFindById(id) {
    this.data.loading = true;
    this.trigger(this.data);
    return SteelCompass.call(
      'payment/incoming',
      'findById',
      { id },
      response => {
        if (response.isError) {
          TransactionActions.genericError(response.errMsg);
        } else {
          TransactionActions.findByIdComplete(response.data);
        }
      }
    );
  },

  onFindByIdComplete(transaction) {
    this.data.loading = false;
    this.data.transaction = transaction;
    this.trigger(this.data);
  },

  onFindByIdError(errorMessage) {
    this.data.loading = false;
    this.data.errorMessage = errorMessage;
    this.trigger(this.data);
  },

  onRefund(id) {
    return SteelCompass.call('payment/incoming', 'refund', { id }, response => {
      if (response.isError) {
        TransactionActions.refundError(response.errMsg);
      } else {
        TransactionActions.refundComplete(response.data);
      }
      this.data.loading = true;
      this.trigger(this.data);
    });
  },

  onResend(id) {
    return SteelCompass.call(
      'payment/incoming',
      'resendReceipt',
      { id },
      response => {
        TransactionActions.resendComplete(response.data);
      }
    );
  },

  onExport(id) {
    return SteelCompass.call('payment/incoming', 'export', { id }, response => {
      TransactionActions.exportComplete(response.data);
    });
  }
});

export default TransactionStore;



// WEBPACK FOOTER //
// ./src/js/stores/Transaction.js